// npm
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

// css
import '../../scss/pages/page-showroom.scss';

// libs
import ShowroomPoint from '../_libs/ShowroomPoint';
import ShowroomQuo from '../_libs/ShowroomQuo';

// utils
import foundation from '../_utils/foundation';
foundation();
import Ease from '../_utils/Ease';

document.addEventListener('DOMContentLoaded', () => {
	const $fv = document.querySelector('.js-fv');
	if ($fv) {
		const $$image = $fv.querySelectorAll('.js-fv-image');

		const mm = gsap.matchMedia();
		let maxCount = 5;
		mm.add('screen and (min-width: 768px)', () => {
			maxCount = 2;
		});

		$$image.forEach(($image, index) => {
			if (index >= maxCount) {
				const observer = new IntersectionObserver(
					(entries) => {
						entries.forEach((entry) => {
							if (entry.isIntersecting) {
								$image.classList.add('is-show');
								observer.disconnect();
							}
						});
					},
					{
						rootMargin: '0px 0px -20% 0px',
					}
				);

				observer.observe($image);
			} else {
				setTimeout(() => {
					$image.classList.add('is-show');
				}, 120 * index);
			}
		});

		// headline
		const $headline = $fv.querySelector('.js-fv-headline');
		const $headlineEn = $headline.querySelector('.js-fv-headline-en');
		const $headlineJa = $headline.querySelector('.js-fv-headline-ja');
		const $headlineScroll = $headline.querySelector(
			'.js-fv-headline-scroll'
		);
		const $$jaChar = $headlineJa.querySelectorAll('.char');

		const headlineTl = gsap.timeline({
			paused: true,
		});

		headlineTl.fromTo(
			$$jaChar,
			{
				display: 'inline-block',
				scale: 1.1,
				opacity: 0,
			},
			{
				scale: 1,
				opacity: 1,
				duration: 0.6,
				stagger: {
					each: 0.02,
					from: 'random',
				},
				ease: Ease.DoubleSineOut,
			}
		);

		headlineTl.fromTo(
			$headlineEn,
			{
				xPercent: 10,
				opacity: 0,
			},
			{
				xPercent: 0,
				opacity: 1,
				duration: 0.6,
				ease: Ease.DoubleSineOut,
			},
			'<'
		);

		headlineTl.fromTo(
			$headlineScroll,
			{
				yPercent: 10,
				opacity: 0,
			},
			{
				yPercent: 0,
				opacity: 1,
				duration: 0.4,
				ease: Ease.DoubleSineOut,
			},
			'-=0.2'
		);

		gsap.set($headline, {
			opacity: 1,
		});

		setTimeout(() => {
			headlineTl.play();
		}, 600);
	}

	const $point = document.querySelector('.js-showroom-point');
	if ($point) {
		ShowroomPoint();
	}

	const $quo = document.querySelector('.js-showroom-quo');
	if ($quo) {
		ShowroomQuo();
	}

	const $go = document.querySelector('.js-go');
	if ($go) {
		const $head = $go.querySelector('.js-go-head');
		const $$headEn = $head.querySelectorAll('.js-go-head-en');
		const $headJa = $head.querySelector('.js-go-head-ja');

		// 重なり
		const $$showroomItem = document.querySelectorAll('.js-showroom-item');
		let $target = null;
		if ($$showroomItem.length > 0) {
			$target = $$showroomItem[$$showroomItem.length - 1];
			const $overlay = document.querySelector('.js-showroom-overlay');

			gsap.to($target, {
				y: '40vh',
				ease: 'none',
				scrollTrigger: {
					trigger: $go,
					start: 'top bottom',
					end: 'top top',
					scrub: true,
					markers: false,
				},
			});

			gsap.to($overlay, {
				opacity: 0.4,
				ease: 'none',
				scrollTrigger: {
					trigger: $go,
					start: 'top bottom',
					end: 'top top',
					scrub: true,
					markers: false,
				},
			});
		}

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						gsap.set($head, {
							opacity: 1,
						});

						gsap.fromTo(
							$$headEn,
							{
								yPercent: 101,
							},
							{
								yPercent: 0,
								duration: 1,
								stagger: 0.08,
								ease: Ease.gleasing,
							}
						);

						gsap.fromTo(
							$headJa,
							{
								yPercent: 101,
								display: 'inline-block',
							},
							{
								yPercent: 0,
								duration: 1,
								ease: Ease.gleasing,
							}
						);

						observer.disconnect();
					}
				});
			},
			{
				rootMargin: '0px 0px -20% 0px',
			}
		);

		observer.observe($head);
	}
});

window.addEventListener('load', () => {});
